import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Form } from "react-bootstrap";
import styles from "./Login.module.css";
import drImage from "../assets/images/dr.jpg";
import Logo from "../assets/images/white.png";
import hidocLogo from "../assets/images/logo_light.png";
import { FiMapPin } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LOGIN_API } from "../utils/constants";
const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handleFooterClick = () => {
    window.open("https://hidocdr.com/", "_blank");
  };
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailParam = encodeURIComponent(email);
    const passwordParam = encodeURIComponent(password);
    const userType = "admin";
    const url = `${LOGIN_API}?email=${emailParam}&pw=${passwordParam}&userType=${userType}`;

    try {
      const response = await axios.post(url);
      if (response.data.success === 1) {
        navigate("/Dashboard");
      } else {
        setError("Invalid credentials. Please try again.");
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
    }
  };

  return (
    <div className={styles.login_main}>
      <div className={styles.login_prent}>
        <div className={styles.dr_image}>
          <img src={drImage} alt="doctor" />
        </div>
        <div className={styles.form_values}>
          <Container>
            <img src={Logo} alt="logo" className={styles.consult_logo} />
            <Form onSubmit={handleSubmit}>
              <div className={styles.inputs}>
                {error && <p className={styles.error_msg}>{error}</p>}
                <Form.Group controlId="email">
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    className={`rounded-pill ${styles.email}`}
                    value={email}
                    onChange={handleEmailChange}
                  />
                </Form.Group>

                <Form.Group controlId="password">
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    className={`rounded-pill mt-3 ${styles.password}`}
                    value={password}
                    onChange={handlePasswordChange}
                  />
                </Form.Group>
              </div>
              <button
                variant="primary"
                type="submit"
                className={`rounded-pill mt-3 ${styles.login_btn}`}
              >
                Login
              </button>
            </Form>
          </Container>
          <div className={styles.logo_parent}>
            <div className={styles.logo_div_login}>
              <FiMapPin color="white" size={22} />
              <p className={styles.logo_text}>
                Hidoc Dr. Inc. | Delaware C Corp | 1309 Coffeen Ave. Suite
                1200,Sheridan WY, 82801
              </p>
            </div>
            <div className={styles.logo_div_login}>
              <HiOutlineMail color="white" size={20} />
              <p className={styles.logo_text}>info@hidoc.co</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.Logo_div}>
        <div>
          <p className={styles.copy_right}>
            © Copyright 2023 Hidoc Dr. Inc.{" "}
            <span className={styles.footer_heading} onClick={handleFooterClick}>
              Terms & Conditions |
            </span>
            <span className={styles.footer_heading} onClick={handleFooterClick}>
              {" "}
              Privacy Policy
            </span>
          </p>
        </div>
        <div className={styles.logo_child}>
          <p className={styles.powered_by_title}>Powered by </p>
          <img src={hidocLogo} alt="hidocLogo" className={styles.hidoc_logo} />
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
